import React from 'react';

import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';

import moment from 'moment';

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        maxHeight: "88vh",
        maxWidth: "90vw",
        overflowY: "auto",
    },
    overlay                 : {zIndex: 1000}
};

function ModalDoubleBookingWarning(props){
    const { isOpen, userName, userRole, conflicts, onConfirm, onCancel } = props;

    function formatWhen(project){
        const start = moment(project.startTime, "YYYY-MM-DD hh:mm");
        const end = moment(project.endTime, "YYYY-MM-DD hh:mm");

        if (end.isValid() && !end.isSame(start, 'day')) {
            return `${start.format('dddd MM/DD h:mm a')} to ${end.format('dddd MM/DD h:mm a')}`;
        }

        return `${start.format('dddd MM/DD')}, ${start.format('h:mm a')}` +
               (end.isValid() ? ` to ${end.format('h:mm a')}` : '');
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            style={customStyles}
            contentLabel="Double Booking Warning"
        >
            <h2 style={{color: '#f00'}}>Scheduling Conflict</h2>

            <p>
                <b>{userName}</b>
                {conflicts.length === 1
                    ? " is already booked on another project that day:"
                    : ` is already booked on ${conflicts.length} other projects that day:`}
            </p>

            <ul>
                {conflicts.map((conflict) => (
                    <li key={conflict.projectID} style={{marginBottom: 10}}>
                        <b>{conflict.project.client}</b>
                        {conflict.project.city ? ` - ${conflict.project.city}` : ''}<br/>
                        {formatWhen(conflict.project)}<br/>
                        <i>{`Status: ${conflict.status}`}</i>
                    </li>
                ))}
            </ul>

            <p>{`Add them to this project as a ${userRole.lower} anyway?`}</p>

            <Button variant="danger" onClick={onConfirm}> Add Anyway </Button>{' '}
            <Button variant="secondary" onClick={onCancel}> Cancel </Button>
        </Modal>
    );
};

export default ModalDoubleBookingWarning;
